var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 73C60.6584 73 77 56.6584 77 36.5C77 16.3416 60.6584 0 40.5 0C20.3416 0 4 16.3416 4 36.5C4 56.6584 20.3416 73 40.5 73Z",
    fill: "url(#paint0_radial_101_7)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9321 45.2422V44.7344C35.9452 42.3776 36.1665 40.5026 36.5962 39.1094C37.0389 37.7161 37.6639 36.5964 38.4712 35.75C39.2785 34.8906 40.2616 34.1029 41.4204 33.3867C42.2147 32.8919 42.9243 32.3516 43.5493 31.7656C44.1873 31.1667 44.6886 30.5026 45.0532 29.7734C45.4178 29.0312 45.6001 28.2044 45.6001 27.293C45.6001 26.2643 45.3592 25.3724 44.8774 24.6172C44.3957 23.862 43.7446 23.276 42.9243 22.8594C42.117 22.4427 41.2121 22.2344 40.2095 22.2344C39.285 22.2344 38.4061 22.4362 37.5728 22.8398C36.7524 23.2305 36.0688 23.8294 35.522 24.6367C34.9881 25.431 34.6886 26.4401 34.6235 27.6641H27.6704C27.7355 25.1901 28.3345 23.1198 29.4673 21.4531C30.6131 19.7865 32.1235 18.5365 33.9985 17.7031C35.8866 16.8698 37.9699 16.4531 40.2485 16.4531C42.7355 16.4531 44.923 16.8893 46.811 17.7617C48.7121 18.6341 50.1899 19.8776 51.2446 21.4922C52.3123 23.0937 52.8462 24.9948 52.8462 27.1953C52.8462 28.6797 52.6053 30.0078 52.1235 31.1797C51.6548 32.3516 50.9842 33.3932 50.1118 34.3047C49.2394 35.2161 48.2043 36.0299 47.0063 36.7461C45.9517 37.3971 45.0858 38.0742 44.4087 38.7773C43.7446 39.4805 43.2498 40.3073 42.9243 41.2578C42.6118 42.1953 42.4491 43.3542 42.436 44.7344V45.2422H35.9321ZM39.3306 57.4297C38.1587 57.4297 37.1496 57.013 36.3032 56.1797C35.4569 55.3464 35.0337 54.3307 35.0337 53.1328C35.0337 51.9609 35.4569 50.9583 36.3032 50.125C37.1496 49.2917 38.1587 48.875 39.3306 48.875C40.4894 48.875 41.492 49.2917 42.3384 50.125C43.1978 50.9583 43.6274 51.9609 43.6274 53.1328C43.6274 53.9271 43.4256 54.6497 43.022 55.3008C42.6313 55.9518 42.1105 56.4727 41.4595 56.8633C40.8215 57.2409 40.1118 57.4297 39.3306 57.4297Z",
    fill: "#2D2D2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_7",
    x: 0,
    y: 0,
    width: 81,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_101_7",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5 36.5) rotate(90) scale(36.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question_mark_icon.4607b739e3e736791ff3f84ad3f9e6b2.svg";
export { ForwardRef as ReactComponent };